export default __webpack_public_path__ + "static/media/gallery-14.7d699a56.jpg";